import generateUtilityClasses from '../../utils/esm/generateUtilityClasses/generateUtilityClasses.esm.js';

const listItemButtonClasses = generateUtilityClasses('MuiListItemButton', ['root', 'focusVisible', 'dense', 'alignItemsFlexStart', 'disabled', 'divider', 'gutters', 'selected']);
var listItemButtonClasses$1 = listItemButtonClasses;

export { listItemButtonClasses$1 as default };
